export const EMAIL_BUILDER_CONTENT_WIDTH_PX = 600;

export const EMAIL_BUILDER_CONTENT_INSET_PX = 24;
